import React from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import ParticipantForm from '../Forms/ParticipantForm';

const ParticipantModal = ({
	dataParticipant,
	isOpen,
	isEdit,
	handleIsEdit,
	handleToggleModal,
	participantsList,
	handleParticipantsList
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='lg'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Participante
			</ModalHeader>

			<ParticipantForm
				dataParticipant={dataParticipant}
				isOpen={isOpen}
				isEdit={isEdit}
				handleIsEdit={handleIsEdit}
				handleToggleModal={handleToggleModal}
				participantsList={participantsList}
				handleParticipantsList={handleParticipantsList}
			/>
		</Modal>
	);
};

export default ParticipantModal;